import axios from 'axios';
import { ResponseSuccessModel } from '../../models/system/responseSuccessModel';
import { API_URL } from '../../config/system/systemConfig';
import { UserModel } from '../../models/platform/userModel';
import { AccountModel } from '../../models/platform/accountModel';
import authHeader from '../../utils/authHeaderUtils';
import { handleAxiosError } from '../../utils/errorUtils';


class AccountApi {

    async getTrialLicense() {
        try {
            const response = await axios.get(`${API_URL}/api/accounts/licenses`,
                {
                    headers: authHeader(),
                });

            return response.data as ResponseSuccessModel;
        }
        catch (error) {
            return handleAxiosError(error);
        }
    }
    async updateAccount(company_name: string, company_size: string) {
        try {
            const payload =
            {
                company_name,
                company_size,
            };

            const response = await axios.post(`${API_URL}/api/accounts`, payload, {
                headers: {
                    ...authHeader(),
                    'Content-Type': 'application/json'
                }
            });

            return response.data as ResponseSuccessModel;
        }
        catch (error) {
            return handleAxiosError(error);
        }
    }

}

const accountApi = new AccountApi();
export default accountApi;
